import { Injectable } from '@angular/core';

@Injectable()
export class ProgressConfig {
  color = 'success';
  thickness = 1;
}
